import * as types from '../../mutation-types'

const mutations = {
  [types.GET_TRAINER] (state, { trainer }) {
    state.trainer = trainer
  },
  [types.SET_IS_TRAINER] (state, { istrainer }) {
    state.istrainer = istrainer
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/trainer/mutations.js